export class TrainPassApplicationSearchCondition
{
    public ym: string
    public empCd: string
    public beforeViewName: string
    public beforeViewParam1: string
    public beforeViewParam2: string
    public beforeViewParam3: string
}

